import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import ConfirmationPopup from 'common/components/popup/confirmation-popup';
import { LeaveConfirmationProps } from './leave-confirmation.model';
import { handleLogout } from 'modules/auth/utils/helpers/auth.helpers';

export const LeaveConfirmation: React.FC<LeaveConfirmationProps> = ({ showQuotePopup, setQuoteShowPopup, showClaimPopup, setClaimShowPopup, nxtRoute, setFileClaimPopup }) => {
  const router = useRouter();
  const { t } = useTranslation();

  function onPopupBtnClicked(action: string): void {
    switch (action) {
      case 'close':
      case 'No': {
        setQuoteShowPopup(false);
        setClaimShowPopup(false);
        setFileClaimPopup(false);
        break;
      }

      case 'yes': {
        setQuoteShowPopup(false);
        window.bannerController('disable');
        window.unSavedChangesInJourney([0]);
        window.unSavedChangesInFnol([0]);
        setClaimShowPopup(false);
  
        if (nxtRoute?.showFileClaimAfter) {
          setFileClaimPopup(true); 
        } else if (nxtRoute?.path) {
          router.push(nxtRoute.path);
        } else if (nxtRoute?.helpParam) {
          router.push({ pathname: nxtRoute.path, query: { help: true } });
        } else if (nxtRoute?.logout) {
          handleLogout();
        }

        break;
      }

      default: {
        setQuoteShowPopup(false);
        setClaimShowPopup(false);
        setFileClaimPopup(false);
        break;
      }
    }
  }

  return (
    <>
      <ConfirmationPopup
        onButtonClicked={onPopupBtnClicked}
        showPopup={showClaimPopup}
        popupMsg={t('claimCreation.leaveConfirmationMsg')}
        yesText={t('claimCreation.leaveConfirmationYesBtn')}
        noText={t('claimCreation.leaveConfirmationNoBtn')}
      />
      <ConfirmationPopup
        onButtonClicked={onPopupBtnClicked}
        showPopup={showQuotePopup}
        popupMsg={t('quoteCreation.leaveConfirmationMsg')}
        yesText={t('quoteCreation.leaveConfirmationYesBtn')}
        noText={t('quoteCreation.leaveConfirmationNoBtn')}
      />
    </>
  );
};
